import { render, staticRenderFns } from "./b2bcontractpurchase_price.vue?vue&type=template&id=42f6257b&scoped=true&"
import script from "./b2bcontractpurchase_price.vue?vue&type=script&lang=js&"
export * from "./b2bcontractpurchase_price.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./b2bcontractpurchase_price.vue?vue&type=style&index=1&id=42f6257b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f6257b",
  null
  
)

export default component.exports